(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1334);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Home": function() { return /* binding */ Home; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/sections/home/about.tsx

var About = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container my-10 grid grid-cols-1 gap-8 lg:grid-cols-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:col-span-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-4 text-start text-3xl font-extrabold sm:text-4xl",
                        children: "Our Mission"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "space-y-8 text-lg text-slate-500",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "max-w-prose text-start",
                            children: "The mission of this student activity is to develop the engineering students in various fields of technology through workshops, projects and competitions, to take out part in providing a generation capable of playing its roles effectively towards itself, community and country."
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var about = (About);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./utils/ui.ts
var ui = __webpack_require__(1244);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/backgroundEffect.tsx






var LeftBackgroundEffect = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var className = _param.className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,ui.cn)("absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80", className),
        "aria-hidden": "true",
        ref: ref
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]",
            style: {
                clipPath: "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
            }
        })
    }));
});
var RightBackgroundEffect = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var className = _param.className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,ui.cn)("absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]", className),
        "aria-hidden": "true",
        ref: ref
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]",
            style: {
                clipPath: "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
            }
        })
    }));
});
var LeftBottomBackgroundEffect = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("section", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "relative isolate px-6 pt-14 lg:px-8",
            children: [
                children,
                /*#__PURE__*/ _jsx(LeftBackgroundEffect, {
                    className: " bottom-0"
                })
            ]
        })
    });
};
var LeftTopRightBottomBackgroundEffect = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative isolate px-6 pt-14 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftBackgroundEffect, {}),
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RightBackgroundEffect, {})
            ]
        })
    });
};
var RightTopLeftBottomBackgroundEffect = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative isolate px-6 pt-14 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RightBackgroundEffect, {}),
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftBackgroundEffect, {})
            ]
        })
    });
};


;// CONCATENATED MODULE: ./components/sections/home/hero.tsx




var Images = [
    "/images/herosection/01.jpg",
    "/images/herosection/02.jpg",
    "/images/herosection/03.jpg",
    "/images/herosection/04.jpg",
    "/images/herosection/05.jpg",
    "/images/herosection/06.jpg",
    "/images/herosection/07.jpg", 
];
var Hero = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftTopRightBottomBackgroundEffect, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "overflow-hidden pt-16 pb-80 sm:pb-40 lg:pr-20 lg:pt-40 lg:pb-48",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container relative my-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sm:max-w-lg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "font text-4xl font-extrabold tracking-tight sm:text-6xl",
                                children: "We are changing the way students think."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-4 text-start text-xl text-slate-500 md:max-w-prose",
                                children: "Here is where you could study, think massively, build things, and share knowledge with students that have the same engineering and technology interest through a series of robotics workshops, competitions and projects."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: "pointer-events-none lg:absolute lg:inset-y-0 lg:mx-auto lg:w-full lg:max-w-7xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute transform sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center space-x-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "grid flex-shrink-0 grid-cols-1 gap-y-6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "h-64 w-44 overflow-hidden rounded-lg sm:opacity-0 lg:opacity-100",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                priority: true,
                                                                width: 10000,
                                                                height: 10000,
                                                                src: Images[0],
                                                                alt: "",
                                                                className: "h-full w-full object-cover object-center"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "h-64 w-44 overflow-hidden rounded-lg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                priority: true,
                                                                width: 10000,
                                                                height: 10000,
                                                                src: Images[1],
                                                                alt: "",
                                                                className: "h-full w-full object-cover object-center"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "grid flex-shrink-0 grid-cols-1 gap-y-6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "h-64 w-44 overflow-hidden rounded-lg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                priority: true,
                                                                width: 10000,
                                                                height: 10000,
                                                                src: Images[2],
                                                                alt: "",
                                                                className: "h-full w-full object-cover object-center"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "h-64 w-44 overflow-hidden rounded-lg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                priority: true,
                                                                width: 10000,
                                                                height: 10000,
                                                                src: Images[3],
                                                                alt: "",
                                                                className: "h-full w-full object-cover object-center"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "h-64 w-44 overflow-hidden rounded-lg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                priority: true,
                                                                width: 10000,
                                                                height: 10000,
                                                                src: Images[4],
                                                                alt: "",
                                                                className: "h-full w-full object-cover object-center"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "grid flex-shrink-0 grid-cols-1 gap-y-6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "h-64 w-44 overflow-hidden rounded-lg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                priority: true,
                                                                width: 10000,
                                                                height: 10000,
                                                                src: Images[5],
                                                                alt: "",
                                                                className: "h-full w-full object-cover object-center"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "h-64 w-44 overflow-hidden rounded-lg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                priority: true,
                                                                width: 10000,
                                                                height: 10000,
                                                                src: Images[6],
                                                                alt: "",
                                                                className: "h-full w-full object-cover object-center"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/events",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "inline-block cursor-pointer rounded-md border border-transparent bg-slate-900 py-3 px-10 text-center font-medium text-white hover:bg-slate-700",
                                        children: "Our Events"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var hero = (Hero);

;// CONCATENATED MODULE: ./components/sections/home/newsLetter.tsx

var NewsLetter = function() {
    return /*#__PURE__*/ _jsx("section", {
        children: /*#__PURE__*/ _jsx("div", {
            className: "container my-10",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "grid gap-20 rounded-md bg-slate-100 py-14 px-6 text-slate-900 shadow dark:bg-slate-800 dark:text-white lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "text-3xl font-extrabold tracking-tight",
                                children: "Join us for our newsletter"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mt-4 text-lg text-slate-500",
                                children: "Join us for our newsletter and stay up-to-date on the latest developments in the exciting world of robotics!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "grid place-items-center",
                        children: /*#__PURE__*/ _jsxs("form", {
                            className: "sm:flex",
                            children: [
                                /*#__PURE__*/ _jsx("label", {
                                    htmlFor: "email-address",
                                    className: "sr-only",
                                    children: "Email address"
                                }),
                                /*#__PURE__*/ _jsx("input", {
                                    id: "email-address",
                                    name: "email-address",
                                    type: "email",
                                    autoComplete: "email",
                                    required: true,
                                    className: "w-full grow rounded-md border-white px-5 py-3 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-700",
                                    placeholder: "Enter your email"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "submit",
                                    className: "mt-3 flex w-full items-center justify-center rounded-md border border-transparent bg-slate-500 px-5 py-3 text-base font-medium text-white hover:bg-slate-400 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-700 sm:mt-0 sm:ml-3 sm:w-auto sm:flex-shrink-0",
                                    children: "Notify me"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var newsLetter = ((/* unused pure expression or super */ null && (NewsLetter)));

;// CONCATENATED MODULE: ./components/sections/home/values.tsx


var features = [
    {
        name: "Innovation",
        description: "We are committed to pushing the boundaries of what's possible in robotics and developing innovative solutions that have a positive impact on society."
    },
    {
        name: "Collaboration",
        description: "We believe in working together with other researchers, engineers, and innovators to achieve our goals and create even more impactful solutions."
    },
    {
        name: "Excellence",
        description: "We strive for excellence in everything we do, from research and development to design and implementation."
    },
    {
        name: "Passion",
        description: "We are passionate about robotics and the potential it has to transform the world we live in."
    },
    {
        name: "Community",
        description: "We believe in building strong, supportive communities around robotics and using our skills and knowledge to make a positive difference in the world."
    },
    {
        name: "Ethics",
        description: "We are committed to ethical and responsible practices in all aspects of our work, including safety, privacy, and inclusively"
    }, 
];
var Values = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RightTopLeftBottomBackgroundEffect, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container my-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "mb-4 text-start text-3xl font-extrabold sm:text-4xl",
                                children: "Our Values"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "max-w-prose text-start text-lg text-slate-500",
                                children: "At our robotic team, we are guided by a set of core values that shape everything we do. These values are:"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                        className: "grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3",
                        children: features.map(function(feature) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-lg font-medium leading-6 text-slate-900 dark:text-slate-50",
                                            children: feature.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                        className: "mt-2 flex text-base text-slate-500 lg:py-0 lg:pb-4",
                                        children: feature.description
                                    })
                                ]
                            }, feature.name);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var values = (Values);

;// CONCATENATED MODULE: ./components/sections/home/landscape.tsx
// this landscape is apeared and rendered in the home page.

var Landscape = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "px-4 lg:px-16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "my-10 lg:container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex min-h-[20rem] w-full flex-col rounded-3xl sm:min-h-[30rem] lg:min-h-[50rem]",
                style: {
                    background: "linear-gradient(rgba(0,0,0,0.1),rgba(0,0,0,0.1)),url('/images/our-team25.jpg')",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover"
                }
            })
        })
    });
};
/* harmony default export */ var landscape = (Landscape);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var next_image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/sections/home/team.tsx


// import { generalSupervisors , supervisors } from "@/pages/team";

var Team = function(param) {
    var _coresMembers = param.coresMembers, coresMembers = _coresMembers === void 0 ? [] : _coresMembers;
    if (!coresMembers.length) {
        return null;
    }
    var generalSupervisors = coresMembers.filter(function(m) {
        return m.group === "general_supervisors";
    });
    var supervisors = coresMembers.filter(function(m) {
        return m.group === "supervisors";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mt-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-12 flex items-center justify-between gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "mb-4 text-start text-3xl font-extrabold sm:text-4xl",
                            children: "Our Team"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/team",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "z-10 inline-block cursor-pointer rounded-md border border-transparent bg-slate-900 py-3 px-10 text-center font-medium text-white hover:bg-slate-700",
                                children: "Meet our team"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto grid max-w-sm grid-cols-2 gap-8 lg:max-w-lg lg:grid-flow-col-dense lg:grid-cols-none",
                    children: generalSupervisors.map(function(member, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "group",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col gap-4 overflow-hidden rounded-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((next_image_default()), {
                                    src: member.thumbnail,
                                    alt: member.name,
                                    width: 1,
                                    height: 1,
                                    layout: "responsive",
                                    priority: true,
                                    className: "object-cover object-center"
                                })
                            })
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto grid max-w-sm grid-cols-3 gap-8 lg:max-w-sm lg:grid-flow-col-dense lg:grid-cols-none",
                    children: supervisors.map(function(member, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "group",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col gap-4 overflow-hidden rounded-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((next_image_default()), {
                                    src: member.thumbnail,
                                    alt: member.name,
                                    width: 1,
                                    height: 1,
                                    layout: "responsive",
                                    priority: true,
                                    className: "object-cover object-center"
                                })
                            })
                        }, i);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var team = (Team);

;// CONCATENATED MODULE: ./components/sections/home/partners.tsx

var partners = [
    {
        thumbnail: "partners/iteda.png",
        name: "ITEDA"
    },
    {
        thumbnail: "partners/tiec.png",
        name: "TIEC"
    },
    {
        thumbnail: "partners/Creativa Logo .PNG",
        name: "CREATIVA"
    },
    // {
    //   thumbnail: "partners/MQR.png",
    //   name: "MQR",
    // },
    {
        thumbnail: "partners/AICL.png",
        name: "AICL"
    }, 
];
var Partners = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container my-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-center text-sm font-semibold uppercase tracking-wide text-slate-600",
                    children: "Trusted by the world's most innovative teams"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto max-w-7xl py-12 px-4 sm:px-6 lg:px-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-4",
                            children: partners.map(function(partner, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                srcSet: "/images/".concat(partner.thumbnail),
                                                type: "image/png"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "h-14 grayscale transition-colors duration-300 hover:grayscale-0 dark:grayscale-0",
                                                src: "/images/".concat(partner.thumbnail),
                                                alt: partner.name
                                            })
                                        ]
                                    })
                                }, i);
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var home_partners = (Partners);

;// CONCATENATED MODULE: ./components/sections/home/quote.tsx


var Quote = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "bg-white pt-16 lg:py-24",
        children: /*#__PURE__*/ _jsx("div", {
            className: "bg-indigo-600 pb-16 lg:relative lg:z-10 lg:pb-0",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-3 lg:gap-8 lg:px-8",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "relative lg:-my-8",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                "aria-hidden": "true",
                                className: "absolute inset-x-0 top-0 h-1/2 bg-white lg:hidden"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:h-full lg:p-0",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "aspect-w-10 aspect-h-6 overflow-hidden rounded-xl shadow-xl sm:aspect-w-16 sm:aspect-h-7 lg:aspect-none lg:h-full",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        className: "object-cover lg:h-full lg:w-full",
                                        src: "https://images.unsplash.com/photo-1520333789090-1afc82db536a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2102&q=80",
                                        alt: ""
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-12 lg:col-span-2 lg:m-0 lg:pl-8",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 lg:max-w-none lg:px-0 lg:py-20",
                            children: /*#__PURE__*/ _jsxs("blockquote", {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx("svg", {
                                                className: "h-12 w-12 text-white opacity-25",
                                                fill: "currentColor",
                                                viewBox: "0 0 32 32",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ _jsx("path", {
                                                    d: "M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "mt-6 text-2xl font-medium text-white",
                                                children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed urna nulla vitae laoreet augue. Amet feugiat est integer dolor auctor adipiscing nunc urna, sit."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("footer", {
                                        className: "mt-6",
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "text-base font-medium text-white",
                                                children: "Judith Black"
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "text-base font-medium text-indigo-100",
                                                children: "CEO at PureInsights"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var quote = ((/* unused pure expression or super */ null && (Quote)));

;// CONCATENATED MODULE: ./components/sections/home/index.ts









;// CONCATENATED MODULE: ./pages/index.tsx


var __N_SSG = true;
var Home = function(param) {
    var _coresMembers = param.coresMembers, coresMembers = _coresMembers === void 0 ? [] : _coresMembers;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(about, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landscape, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(team, {
                coresMembers: coresMembers
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(values, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_partners, {})
        ]
    });
};
/* harmony default export */ var pages = (Home); // import { About } from "components/sections/about";
 // import { Hero } from "components/sections/hero";
 // import { PortfolioPreview } from "components/sections/portfolio-preview";
 // import { Timeline } from "components/sections/timeline";
 // import party from "party-js";
 // import { FC } from "react";
 // import { components } from "twitter-api-sdk/dist/gen/openapi-types";
 // import Home from "./home";
 // type IndexProps = {
 //   twitterData: components["schemas"]["User"];
 // };
 // party.settings.respectReducedMotion = false;
 // export const Index: FC<IndexProps> = () => {
 //   return (
 //     <>
 //       <Home />
 //       {/* <Hero /> */}
 //       {/* <About /> */}
 //       {/* <Timeline /> */}
 //       {/* <PortfolioPreview /> */}
 //     </>
 //   );
 // };
 // export default Index;
 // {/* <Hero url={teamImage.src}>
 //   <div className="container grid grow place-content-center place-items-end">
 //     <h1 className="text-center text-9xl font-extrabold tracking-widest">
 //       <span className="font-londrina uppercase text-white">Apel</span>
 //       <span className="font-londrina-outlined uppercase text-slate-100">team</span>
 //     </h1>
 //   </div>
 // </Hero>
 // <section className="relative overflow-hidden">
 //   <div className="container my-20">
 //     <p className="mx-auto max-w-prose text-center">
 //       Aswan Practical Engineering Lab is a student activity in Aswan Faculty of Engineering
 //       Interested in teaching students about robotics and programming through technical
 //       sessions and organizing national Robotics competition every year
 //     </p>
 //     <div className="float-right mt-10">
 //       <Link href="/about">About us →</Link>
 //     </div>
 //   </div>
 // </section> */}
 // {/* <section className="col-span-3">
 //   <div className="container">
 //     <h1 className="heading-xl -ml-1">Upcomming Events</h1>
 //     <p className="text-center font-serif text-4xl">
 //       <span className="text-6xl text-cyan-600">ARC7 PHASE2</span>
 //       <br />
 //       Soon
 //       <br />
 //       Waiting You...
 //     </p>
 //   </div>
 // </section> */}
 // {/* <section className="col-span-3">
 //   <div className="container">
 //     <h1 className="heading-xl -ml-1">Partners</h1>
 //     <div className="grid grid-cols-3 gap-8 md:grid-cols-4 lg:grid-cols-6">
 //       {partners.map((member, index) => (
 //         <div key={member.name} className="group">
 //           <div className="flex flex-col gap-4 overflow-hidden rounded-full">
 //             // <Image
 //               src={`/images/${member.thumbnail}`}
 //               alt={member.name}
 //               width={1}
 //               height={1}
 //               layout="responsive"
 //               priority
 //               // className="transition-transform duration-300 group-hover:scale-105"
 //             />
 //           </div>
 //         </div>
 //       ))}
 //     </div>
 //   </div>
 // </section> */}


/***/ }),

/***/ 1244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6010);

// import { twMerge } from "tailwind-merge";
function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,clsx__WEBPACK_IMPORTED_MODULE_0__/* .clsx */ .W)(inputs);
//   twMerge(clsx(inputs));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [608,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);